module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/efc0f24a3d0ebe9ccdfd7392058f8274.gif";